module.exports = __webpack_public_path__ + "img/anukin.a1aec86a.png";